<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <nav class="header-navigation">
    <RouterLink :to="{ name: 'HomeView' }" class="header-item">
      {{ t("nav.home") }}
    </RouterLink>
    <RouterLink :to="{ name: 'ReceiveView' }" class="header-item">
      {{ t("nav.receive") }}
    </RouterLink>
    <RouterLink :to="{ name: 'SpendView' }" class="header-item">
      {{ t("nav.spend") }}
    </RouterLink>
    <RouterLink :to="{ name: 'FundView' }" class="header-item fund">
      <img src="@/assets/images/fund-logo.svg" alt="" />
      {{ t("header.fund") }}
    </RouterLink>
    <a href="https://rc.shopping/" class="header-item" target="_blank">
      <img src="@/assets/images/market-logo.svg" alt="RC MARKET" />
      RC MARKET
    </a>
  </nav>
</template>

<style scoped lang="scss">
.header-navigation {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: calc($base-space * 3);
}

.fund {
  color: var(--color-semantic-content-hover-link);
}
</style>
